import { HTMLStyledProps, forwardRef, Box } from "@design-system/core"

import * as React from "react"
import { useFormControlContext } from "./form-control"

export interface FormErrorMessageProps extends HTMLStyledProps<"div"> {}

/**
 * Used to provide feedback about an invalid input,
 * and suggest clear instructions on how to fix it.
 */
export const FormErrorMessage = forwardRef<FormErrorMessageProps, "div">(
  (props, ref) => {
    const field = useFormControlContext()
    const { style, ...rest } = props

    if (!field?.isInvalid) return null

    return (
      <Box
        {...field?.getErrorMessageProps(rest, ref)}
        style={style}
      />
    )
  },
)
